import axios from "axios";

export function getInformes() {
  return axios.get('/api/informes')
}